export default __webpack_public_path__ + "static/media/img-0479-bulgaria-premium-face.e735c34b.png";